import { AvailableIcon } from '../../../../../components/atoms/Icon';

export type PlanDetailsType = {
  designedFor: string;
  bestSuitedFor: string;
  mediaScope: string;
  modelRefresh: string;
  coreInclusions: Record<string, boolean>;
  fullFeatures: Record<string, boolean>;
};

export type PricingPlansType = {
  'DIGITAL BASELINE': PlanDetailsType;
  'DIGITAL ADVANCED': PlanDetailsType;
  'CROSS-CHANNEL GROWTH': PlanDetailsType;
  'FULL-SCALE ENTERPRISE': PlanDetailsType;
};

export const pricingPlans: PricingPlansType = {
  'DIGITAL BASELINE': {
    designedFor:
      "Marketers starting with digital measurement to understand what's actually working",
    bestSuitedFor: 'Digital-only advertisers, SMBs',
    mediaScope: 'Digital only',
    modelRefresh: 'Monthly',
    coreInclusions: {
      'Digital performance dashboard': true,
      'Models built on your marketing data': true,
      'Supports major global advertising platforms': true,
      'Marketing optimization': true,
    },
    fullFeatures: {
      'Digital attribution across platforms (Google, Meta, etc.)': true,
      'Automatic daily or weekly data pulls': true,
      'Statistical analysis with Bayesian modeling': true,
      'Granular KPI analytics': true,
      'Response curves with optimal spend indicators': true,
      'Brand tracking': true,
      'Goal setting and performance tracking': true,
      'Predicted sales': true,
      Forecasting: true,
      'Exportable Excel and CSV reports': true,
      'Period-over-period benchmarking': true,
      'Sales and media trends': true,
      'Time period comparison': true,
      'Automated external data enrichment': false,
      'Offline media modeling (TV, radio, OOH, print)': false,
      // 'ROI by media channel': false,
      'Long-term media effect': false,
    },
  },
  'DIGITAL ADVANCED': {
    designedFor:
      'Growth-oriented digital advertisers with specific performance goals',
    bestSuitedFor:
      'Online retail, mobile apps, digital subscription businesses',
    mediaScope: 'Digital only',
    modelRefresh: 'Weekly',
    coreInclusions: {
      'Digital performance dashboard': true,
      'Models built on your marketing data': true,
      'Supports major global advertising platforms': true,
      'Marketing optimization': true,
    },
    fullFeatures: {
      'Digital attribution across platforms (Google, Meta, etc.)': true,
      'Automatic daily or weekly data pulls': true,
      'Statistical analysis with Bayesian modeling': true,
      'Granular KPI analytics': true,
      'Response curves with optimal spend indicators': true,
      'Brand tracking': true,
      'Goal setting and performance tracking': true,
      'Predicted sales': true,
      Forecasting: true,
      'Exportable Excel and CSV reports': true,
      'Period-over-period benchmarking': true,
      'Sales and media trends': true,
      'Time period comparison': true,
      'Automated external data enrichment': false,
      'Offline media modeling (TV, radio, OOH, print)': false,
      // 'ROI by media channel': false,
      'Long-term media effect': false,
    },
  },
  'CROSS-CHANNEL GROWTH': {
    designedFor: 'Cross-channel marketers blending online and offline',
    bestSuitedFor:
      'Retail networks, automotive dealers, regional and national brands',
    mediaScope: 'Digital and Offline',
    modelRefresh: 'Monthly',
    coreInclusions: {
      'Digital performance dashboard': true,
      'Models built on your marketing data': true,
      'Supports major global advertising platforms': true,
      'Marketing optimization': true,
    },
    fullFeatures: {
      'Digital attribution across platforms (Google, Meta, etc.)': true,
      'Automatic daily or weekly data pulls': true,
      'Statistical analysis with Bayesian modeling': true,
      'Granular KPI analytics': true,
      'Response curves with optimal spend indicators': true,
      'Brand tracking': true,
      'Goal setting and performance tracking': true,
      'Predicted sales': true,
      Forecasting: true,
      'Exportable Excel and CSV reports': true,
      'Period-over-period benchmarking': true,
      'Sales and media trends': true,
      'Time period comparison': true,
      'Automated external data enrichment': true,
      'Offline media modeling (TV, radio, OOH, print)': true,
      // 'ROI by media channel': false,
      'Long-term media effect': true,
    },
  },
  'FULL-SCALE ENTERPRISE': {
    designedFor: 'Large-scale media operations and distributed teams',
    bestSuitedFor: 'National brands, agencies, multi-market organizations',
    mediaScope: 'Digital and Offline',
    modelRefresh: 'Weekly',
    coreInclusions: {
      'Digital performance dashboard': true,
      'Models built on your marketing data': true,
      'Supports major global advertising platforms': true,
      'Marketing optimization': true,
    },
    fullFeatures: {
      'Digital attribution across platforms (Google, Meta, etc.)': true,
      'Automatic daily or weekly data pulls': true,
      'Statistical analysis with Bayesian modeling': true,
      'Granular KPI analytics': true,
      'Response curves with optimal spend indicators': true,
      'Brand tracking': true,
      'Goal setting and performance tracking': true,
      'Predicted sales': true,
      Forecasting: true,
      'Exportable Excel and CSV reports': true,
      'Period-over-period benchmarking': true,
      'Sales and media trends': true,
      'Time period comparison': true,
      'Automated external data enrichment': true,
      'Offline media modeling (TV, radio, OOH, print)': true,
      // 'ROI by media channel': true,
      'Long-term media effect': true,
    },
  },
};

export const planDetails: Array<{
  label: string;
  icon: AvailableIcon;
  key: keyof Omit<PlanDetailsType, 'coreInclusions' | 'fullFeatures'>;
}> = [
  { label: 'Designed for:', icon: 'circle-checkbox', key: 'designedFor' },
  { label: 'Best suited for:', icon: 'graph', key: 'bestSuitedFor' },
  { label: 'Media scope:', icon: 'media', key: 'mediaScope' },
  { label: 'Model refresh:', icon: 'refresh', key: 'modelRefresh' },
];
